import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { UserFormData } from 'types/user';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { getUserProfile, updateUserProfile } from 'services/userService';
import { UserProfileForm } from 'components/UserProfile/UserProfileForm';
import { useDidMount } from 'hooks/useDidMount';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const UpdateUserPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<UserFormData>();

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const updateHandler = useCallback(
        (formData: UserFormData) => {
            if (id) {
                setIsLoading(true);
                updateUserProfile(formData, id)
                    .then(() => {
                        notifications.show({ message: 'User successfully updated' });
                        navigate(-1);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        },
        [id, notifications],
    );

    useDidMount(() => {
        if (id) {
            setIsLoading(true);
            getUserProfile(id)
                .then(setData)
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Update User" sx={cardStyles}>
                {data && <UserProfileForm initialData={data} onSubmit={updateHandler} />}
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
